import { render, staticRenderFns } from "./EditarProrrogacoes.vue?vue&type=template&id=d4fa1f12"
import script from "./EditarProrrogacoes.vue?vue&type=script&lang=ts"
export * from "./EditarProrrogacoes.vue?vue&type=script&lang=ts"
import style0 from "./EditarProrrogacoes.vue?vue&type=style&index=0&id=d4fa1f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports